import { cn } from '../../utils/cn';
import {
  resolveIncomeSourceColor,
  resolveIncomeSourceIcon,
} from '../../utils/incomeSourceIcons';

/**
 * Badge com ícone da fonte de rendimento (cor da fonte no glifo).
 *
 * `background`:
 * - `tint`  → fundo com a própria cor da fonte a 20% (usado nas listas de fontes)
 * - `muted` → fundo neutro `$surface-muted` do `.pen`
 *   (`ds/card/income-source` › `chip`, `ds/card/record-day-group` › `chip`)
 */
export function IncomeSourceIcon({
  source,
  size = 'md',
  background = 'tint',
  className,
  iconClassName,
}) {
  const Icon = resolveIncomeSourceIcon(source);
  const color = resolveIncomeSourceColor(source);

  const sizes = {
    sm: { wrap: 'h-6 w-6', icon: 'h-3 w-3' },
    md: { wrap: 'h-8 w-8', icon: 'h-4 w-4' },
    lg: { wrap: 'h-10 w-10', icon: 'h-5 w-5' },
  };
  const dim = sizes[size] || sizes.md;
  const isMuted = background === 'muted';

  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full',
        dim.wrap,
        isMuted && 'bg-muted',
        className,
      )}
      style={isMuted ? undefined : { backgroundColor: `${color}33` }}
    >
      <Icon
        className={cn(dim.icon, iconClassName)}
        style={{ color }}
        aria-hidden
      />
    </span>
  );
}
